var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("GuidelineAnalyteDefaultValues", {
    attrs: { title: "Default values", mapSameAnalyte: _vm.mapSameAnalyte },
    on: {
      notify: function ($event) {
        return _vm.$emit("notify", $event)
      },
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }